import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import useReencauche from "../../../hooks/administrador/reencauche/useReencauche";
import "../../../styles/administrador.css";

const Reencauche = ({ year, mes, token, idAdministrador }) => {
  const chartRef = useRef(null);
  const { data, loading, error } = useReencauche(
    year,
    mes,
    token,
    idAdministrador
  );

  useEffect(() => {
    if (loading || !chartRef.current) return;

    if (error || !Array.isArray(data) || data.length === 0) {
      if (chartRef.current) {
        chartRef.current.innerHTML =
          "<p style='text-align: center; color: black;'>No hay datos disponibles</p>";
      }
      return;
    }

    const chartDom = chartRef.current;
    let myChart = echarts.getInstanceByDom(chartDom);
    if (myChart) myChart.dispose();
    myChart = echarts.init(chartDom);

    const colorPalette = [
      "#d1dc5a",
      "#6ac5cb",
      "#45444e",
      "#a3b85b",
      "#3a6b74",
      "#7d8a2e",
      "#3d9199",
      "#62615e",
      "#879b4a",
      "#2b5258",
    ];

    const totalReencauche = data.reduce(
      (sum, item) => sum + parseFloat(item.cantidad || 0),
      0
    );

    const groupedData = {};
    data.forEach((item) => {
      const mes = item.mes;
      const empresa = item.razon_social;
      const cantidad = parseFloat(item.cantidad || 0);

      if (!groupedData[mes]) {
        groupedData[mes] = {};
      }
      if (!groupedData[mes][empresa]) {
        groupedData[mes][empresa] = 0;
      }

      groupedData[mes][empresa] += cantidad;
    });

    const nombresMeses = {
      Enero: 1,
      Febrero: 2,
      Marzo: 3,
      Abril: 4,
      Mayo: 5,
      Junio: 6,
      Julio: 7,
      Agosto: 8,
      Septiembre: 9,
      Octubre: 10,
      Noviembre: 11,
      Diciembre: 12,
    };

    const mesesOrdenados = Object.keys(groupedData).sort(
      (a, b) => nombresMeses[a] - nombresMeses[b]
    );
    const mesesFormateados = mesesOrdenados.map((mes) =>
      mes.substring(0, 3).toUpperCase()
    );
    const empresas = [...new Set(data.map((item) => item.razon_social))];

    const seriesData = empresas.map((empresa, index) => ({
      name: empresa,
      type: "bar",
      stack: "total",
      data: mesesOrdenados.map((mes) => groupedData[mes][empresa] || 0),
      itemStyle: {
        color: colorPalette[index % colorPalette.length],
      },
    }));

    const option = {
      title: {
        text: "Reencauche por miembro adherido",
        left: "center",
        subtext: `TOTAL REENCAUCHE: ${totalReencauche.toLocaleString()}`,
        textStyle: {
          fontSize: 18,
          fontWeight: "bold",
        },
        subtextStyle: {
          fontSize: 12,
          fontWeight: "bold",
        },
      },
      tooltip: {
        trigger: "axis",
        confine: true,
        axisPointer: {
          type: "shadow",
        },
        textStyle: {
          fontSize: 10,  
        },
        formatter: function (params) {
          let total = 0;
          let tooltipText = params[0].axisValueLabel + "<br/>";
          params.sort((a, b) => b.value - a.value);
          params.forEach((param) => {
            let formattedName = param.seriesName;
            if (formattedName.length > 15) {
               
              const words = formattedName.split(" ");
              formattedName = "";
              for (let i = 0; i < words.length; i++) {
                formattedName += words[i];
                if ((i + 1) % 2 === 0 || i === words.length - 1) {
                  formattedName += "<br/>";  
                } else {
                  formattedName += " ";  
                }
              }
            }
            tooltipText += `${
              param.marker
            } <b>${formattedName}</b>: ${param.value.toLocaleString()}<br/>`;
            total += param.value;
          });
          tooltipText += `<br/><b>Total: ${total.toLocaleString()}</b>`;
          return tooltipText;
        },
      },
      legend: {
        data: empresas,
        bottom: 10,
        type: "scroll",
        orient: "horizontal",
        itemWidth: 12,
        itemHeight: 10,
        textStyle: {
          fontSize: 11,
        },
        formatter: function (name) {
          if (name.length > 15) {
            return name.substring(0, 15) + "...";
          }
          return name;
        },
      },
      xAxis: {
        type: "category",
        data: mesesFormateados,
        axisLabel: {
          fontWeight: "bold",
          interval: 0,
          rotate: 0,
          width: 40,
          overflow: "truncate",
        },
      },
      yAxis: {
        type: "value",
        name: "Cantidad",
      },
      series: seriesData,
      grid: {
        left: "3%",
        right: "4%",
        bottom: "20%",
        top: "20%",
        containLabel: true,
      },
    };

    myChart.setOption(option);

    const updateChart = () => {
      myChart.resize();
    };

    window.addEventListener("resize", updateChart);

    return () => {
      window.removeEventListener("resize", updateChart);
      if (myChart && !myChart.isDisposed()) {
        myChart.dispose();
      }
    };
  }, [data, loading, error]);

  if (loading) {
    return (
      <div className="grafica loading">Cargando datos de reencauche...</div>
    );
  }

  return <div className="grafica" ref={chartRef}></div>;
};

export default Reencauche;
